// import { useEffect, useState } from "react";

// export default function AnimatedCounter({
//   target = 1000,
//   duration = 2000,
//   suffix = "+",
//   className = "text-[#FF2F5E] text-[15px] font-semibold tracking-[-1px]",
// }) {
//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     let startTimestamp = null;
//     const step = (timestamp) => {
//       if (!startTimestamp) startTimestamp = timestamp;
//       const progress = Math.min((timestamp - startTimestamp) / duration, 1);
//       setCount(Math.floor(progress * target));
//       if (progress < 1) {
//         requestAnimationFrame(step);
//       }
//     };
//     requestAnimationFrame(step);
//   }, [target, duration]);

//   return (
//     <p className={className}>
//       {count.toLocaleString()}
//       {suffix}
//     </p>
//   );
// }

// import { useEffect, useRef, useState } from "react";

// export default function AnimatedCounter({
//   target = 1000,
//   duration = 2000,
//   suffix = "+",
//   className = "text-[#FF2F5E] text-[15px] font-semibold tracking-[-1px]",
// }) {
//   const [count, setCount] = useState(0);
//   const [isVisible, setIsVisible] = useState(false);
//   const ref = useRef(null);

//   // Start animation only when visible
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setIsVisible(true);
//           observer.disconnect();
//         }
//       },
//       { threshold: 0.3 } // triggers when 30% visible
//     );

//     if (ref.current) observer.observe(ref.current);
//     return () => observer.disconnect();
//   }, []);

//   // Animate only after visible
//   useEffect(() => {
//     if (!isVisible) return;

//     let startTimestamp = null;
//     const step = (timestamp) => {
//       if (!startTimestamp) startTimestamp = timestamp;
//       const progress = Math.min((timestamp - startTimestamp) / duration, 1);
//       setCount(Math.floor(progress * target));
//       if (progress < 1) {
//         requestAnimationFrame(step);
//       }
//     };
//     requestAnimationFrame(step);
//   }, [isVisible, target, duration]);

//   // Fix movement: reserve width based on max digits
//   const maxDigits = target.toLocaleString().length;

//   return (
//     <p
//       ref={ref}
//       className={className}
//       style={{
//         display: "inline-block",
//         width: `${maxDigits}ch`,
//         textAlign: "center",
//       }}
//     >
//       {count.toLocaleString()}
//       {suffix}
//     </p>
//   );
// }

// import { useEffect, useRef, useState } from "react";

// export default function AnimatedCounter({
//   target = 1000,
//   duration = 2000,
//   suffix = "+",
//   className = "text-[#FF2F5E] text-[15px] font-semibold tracking-[-1px]",
// }) {
//   const [count, setCount] = useState(0);
//   const [isVisible, setIsVisible] = useState(false);
//   const ref = useRef(null);

//   // Start animation when visible
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setIsVisible(true);
//           observer.disconnect();
//         }
//       },
//       { threshold: 0.3 }
//     );

//     if (ref.current) observer.observe(ref.current);
//     return () => observer.disconnect();
//   }, []);

//   // Animate after visible
//   useEffect(() => {
//     if (!isVisible) return;

//     let start = null;
//     const step = (timestamp) => {
//       if (!start) start = timestamp;
//       const progress = Math.min((timestamp - start) / duration, 1);
//       setCount(Math.floor(progress * target));
//       if (progress < 1) requestAnimationFrame(step);
//     };
//     requestAnimationFrame(step);
//   }, [isVisible, target, duration]);

//   // Calculate width based on max digits INCLUDING suffix
//   const maxText = `${target.toLocaleString()}${suffix}`;
//   const maxWidth = maxText.length;

//   return (
//     <div
//       ref={ref}
//       className={className}
//       style={{
//         display: "inline-flex",
//         justifyContent: "center",
//         alignItems: "center",
//         width: `${maxWidth}ch`, // reserve space for full final string
//         textAlign: "center",
//       }}
//     >
//       {count.toLocaleString()}
//       {suffix}
//     </div>
//   );
// }

// import { useEffect, useRef, useState } from "react";

// export default function AnimatedCounter({
//   target = 1000,
//   duration = 2000,
//   suffix = "+",
//   className = "text-[#FF2F5E] text-[15px] font-semibold tracking-[-1px]",
// }) {
//   const [count, setCount] = useState(0);
//   const [isVisible, setIsVisible] = useState(false);
//   const ref = useRef(null);

//   // When visible → start
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setIsVisible(true);
//           observer.disconnect();
//         }
//       },
//       { threshold: 0.3 }
//     );

//     if (ref.current) observer.observe(ref.current);
//     return () => observer.disconnect();
//   }, []);

//   // Animation
//   useEffect(() => {
//     if (!isVisible) return;

//     let start = null;

//     const step = (timestamp) => {
//       if (!start) start = timestamp;
//       const progress = Math.min((timestamp - start) / duration, 1);

//       setCount(progress * target); // <— KEEP DECIMALS

//       if (progress < 1) requestAnimationFrame(step);
//     };

//     requestAnimationFrame(step);
//   }, [isVisible, target, duration]);

//   // Format with decimals like 1.1M, 2.4K, etc.
//   const formatNumber = (num) => {
//     if (num >= 1_000_000_000)
//       return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";

//     if (num >= 1_000_000)
//       return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";

//     if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";

//     return Math.floor(num).toLocaleString();
//   };

//   // Pre-calc width for stable layout
//   const maxText = `${formatNumber(target)}${suffix}`;
//   const maxWidth = maxText.length;

//   return (
//     <div
//       ref={ref}
//       className={className}
//       style={{
//         display: "inline-flex",
//         justifyContent: "center",
//         alignItems: "center",
//         width: `${maxWidth}ch`,
//         textAlign: "center",
//       }}
//     >
//       {formatNumber(count)}
//       {suffix}
//     </div>
//   );
// }

import { useEffect, useRef, useState } from "react";

export default function AnimatedCounter({
  target = 1000,
  duration = 2000,
  suffix = "+",
  className = "text-[#FF2F5E] text-[15px] font-semibold tracking-[-1px]",
}) {
  const [count, setCount] = useState(target < 10 ? target : 0); // 👈 Instant for single-digit
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  const shouldAnimate = target >= 10; // 👈 Only animate 10+

  // Visibility observer
  useEffect(() => {
    if (!shouldAnimate) return; // 👈 Skip observer for single-digit

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [shouldAnimate]);

  // Animation effect
  useEffect(() => {
    if (!shouldAnimate || !isVisible) return; // 👈 No animation for < 10

    let start = null;

    const step = (timestamp) => {
      if (!start) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);
      setCount(progress * target);

      if (progress < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  }, [isVisible, target, duration, shouldAnimate]);

  // Number formatting
  const formatNumber = (num) => {
    if (num >= 1_000_000_000)
      return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";

    if (num >= 1_000_000)
      return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";

    if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";

    return Math.floor(num).toLocaleString();
  };

  const maxText = `${formatNumber(target)}${suffix}`;
  const maxWidth = maxText.length;

  return (
    <div
      ref={ref}
      className={className}
      style={{
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        width: `${maxWidth}ch`,
        textAlign: "center",
      }}
    >
      {formatNumber(count)}
      {suffix}
    </div>
  );
}

// import { useEffect, useRef, useState } from "react";

// export default function AnimatedCounter({
//   target = 1000,
//   duration = 2000,
//   suffix = "+",
//   className = "text-[#FF2F5E] text-[15px] font-semibold tracking-[-1px]",
// }) {
//   const [count, setCount] = useState(target < 10 ? target : 0);
//   const [isVisible, setIsVisible] = useState(false);
//   const ref = useRef(null);

//   const shouldAnimate = target >= 10;

//   // Visibility observer
//   useEffect(() => {
//     if (!shouldAnimate) return;

//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setIsVisible(true);
//           observer.disconnect();
//         }
//       },
//       { threshold: 0.3 }
//     );

//     if (ref.current) observer.observe(ref.current);
//     return () => observer.disconnect();
//   }, [shouldAnimate]);

//   // Animation effect
//   useEffect(() => {
//     if (!shouldAnimate || !isVisible) return;

//     let start = null;

//     const step = (timestamp) => {
//       if (!start) start = timestamp;
//       const progress = Math.min((timestamp - start) / duration, 1);
//       setCount(progress * target);

//       if (progress < 1) requestAnimationFrame(step);
//     };

//     requestAnimationFrame(step);
//   }, [isVisible, target, duration, shouldAnimate]);

//   // Number formatting
//   const formatNumber = (num) => {
//     if (num >= 1_000_000_000)
//       return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";

//     if (num >= 1_000_000)
//       return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";

//     if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";

//     return Math.floor(num).toLocaleString();
//   };

//   // max width ONLY for number
//   const maxNumberText = formatNumber(target);
//   const maxWidth = `${maxNumberText.length}ch`;

//   return (
//     <div
//       ref={ref}
//       className={className}
//       style={{
//         display: "inline-flex",
//         alignItems: "center",
//       }}
//     >
//       {/* STATIC WIDTH WRAPPER FOR NUMBER */}
//       <span
//         style={{
//           display: "inline-block",
//           width: maxWidth,
//           textAlign: "right",
//         }}
//       >
//         {formatNumber(count)}
//       </span>

//       {/* SUFFIX DOES NOT MOVE */}
//       <span style={{ marginLeft: "2px" }}>{suffix}</span>
//     </div>
//   );
// }
